module.exports = require("basic-auth");


/*****************
 ** WEBPACK FOOTER
 ** external "basic-auth"
 ** module id = 1
 ** module chunks = 0
 **/